import { get, computed } from '@ember/object';
import Ember from 'ember';

export default function (dependentKey) {
  return computed(dependentKey, function () {
    const val = get(this, dependentKey);
    return Ember.Handlebars.Utils.escapeExpression(val);
  });
}
